import { ArrowUpBold } from "@element-plus/icons-vue";
export default {
  name: "BackTop",
  components: {
    ArrowUpBold
  },
  props: {
    bottom: {
      type: Number,
      default: 155
    },
    right: {
      type: Number,
      default: 30
    },
    bgColor: {
      type: String,
      default: "#b6aaf9"
    }
  },
  data() {
    return {
      showButton: false
    };
  },
  mounted() {
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
    this.$el.parentElement.addEventListener("scroll", this.checkScroll);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScroll);
    this.$el.parentElement.removeEventListener("scroll", this.checkScroll);
  },
  methods: {
    scrollToTop() {
      const container = this.$el.parentElement;
      container.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    checkScroll() {
      const container = this.$el.parentElement;
      this.showButton = container.scrollTop > 50;
    }
  }
};